import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import massiveImport from 'api/administration/monitoring/massiveImport'
import UploadFileV1 from 'components/ui/modals/UploadFile/V1'
import { isExcelFile } from 'helpers'
import { useTranslationRankmi } from 'helpers/translations.helper'

interface IMassiveImportProps {
  courseId: number | string
  show: boolean
  setShow: (show: boolean) => void
  error: React.ReactNode
  setError: (error: React.ReactNode) => void
}

const MassiveImport: React.FC<IMassiveImportProps> = ({
  courseId,
  show,
  setShow,
  error,
  setError,
}) => {
  const [showFile, setShowFile] = useState(false)

  const tUpload = useTranslationRankmi({
    prefix:
      'administration.courses.list.dropdown.importParticipantsManually.modal',
  })

  const handleFileUpload = (file: File) => {
    setError(null)
    if (!isExcelFile(file)) {
      setTimeout(() => {
        setError(<>{tUpload('error')}</>)
      }, 500)
      return
    }
    if (file) massiveImport(courseId, file)
    setShowFile(false)
    setShow(false)
  }

  return (
    <UploadFileV1
      title={tUpload('modalTitle')}
      show={show}
      onClose={() => setShow(false)}
      onUpload={handleFileUpload}
      error={error}
      template={{
        link: 'https://rankmi-lms-prod.s3.amazonaws.com/templates/massive_import_nlmsp_template.xlsx',
        label: tUpload('template'),
      }}
      labels={{
        legend: tUpload('legendUnstarted'),
        addFile: tUpload('addFile'),
        close: tUpload('close'),
      }}
    />
  )
}

export default MassiveImport
